// src/extenders/submit-blinds-form.js
if (!customElements.get("submit-blinds-form")) {
  customElements.define(
    "submit-blinds-form",
    class SubmitBlindsForm extends HTMLElement {
      constructor() {
        super();
        this.submitButtonElement = this.querySelector("button");
        this.submitButtonElement.addEventListener("click", () => {
          this.handleSubmitBlindsForm();
        });
      }
      handleSubmitBlindsForm() {
        const blindsForm = document.querySelector("blinds-form");
        const realBlindsSubmitButton = blindsForm.querySelector('button[type="submit"]');
        this.submitButtonElement.setAttribute("aria-disabled", true);
        this.submitButtonElement.setAttribute("aria-busy", true);
        realBlindsSubmitButton.click();
        setTimeout(() => {
          this.submitButtonElement.setAttribute("aria-disabled", false);
          this.submitButtonElement.setAttribute("aria-busy", false);
        }, 1e3);
      }
    }
  );
}
